import script from "./RidEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./RidEntity.vue?vue&type=script&setup=true&lang=js"

import "./RidEntity.vue?vue&type=style&index=0&id=78c14394&scoped=true&lang=scss"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c14394"]])

export default __exports__